import { FloatingFocusManager, FloatingPortal } from '@floating-ui/react';
import classNames from 'classnames';
import React from 'react';
import styles from "./Floating.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function Floating({
  floating,
  isOpen,
  children,
  getFloatingProps,
  width,
  small,
  name
}) {
  return /*#__PURE__*/_jsx(FloatingPortal, {
    children: isOpen && /*#__PURE__*/_jsx(FloatingFocusManager, {
      context: floating.context,
      modal: false,
      initialFocus: -1,
      children: /*#__PURE__*/_jsx("div", {
        ref: floating.refs.setFloating,
        className: classNames(styles.menu, {
          [styles.small]: small
        }),
        style: {
          position: floating.strategy,
          top: floating.y ?? 0,
          left: floating.x ?? 0,
          width: width ? `${width}px` : 'max-content'
        },
        "aria-haspopup": "listbox",
        "aria-expanded": isOpen ? true : undefined,
        "data-testid": name ? `dropdown-container-${name}` : undefined,
        ...getFloatingProps(),
        children: children
      })
    })
  });
}